export const GET_RACE_CARD_LIST = `
query RaceCardProfile($date: String, $venueCode: String, $type: STStatType, $ids: [String!], $raceNumber: String, $meetingDate: String) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    totalNumberOfRace
    status
    pmPools {
      leg {
        races
      }
      status
      oddsType
    }
    races {
      id
      no
      status
      postTime
      raceName_en
      raceName_ch
      raceResults {
        status
      }
      countryCodeNm {
        code
        english
        chinese
      }
      distance
      raceCourse {
        code
        description_en
        description_ch
      }
      raceTrack {
        code
        description_en
        description_ch
      }
      raceType_en
      raceType_ch
      raceClass_en
      raceClass_ch
      country_en
      country_ch
      winningMargin {
        seqNo
        lbw
      }
      go_en
      go_ch
      remarks {
        name_en
        name_ch
        seqNo
      }
      runners {
        horse {
          name_en
          name_ch
          id
        }
        status
        color
        no
        handicapWeight
        jockey {
          code
          name_en
          name_ch
        }
        trainer {
          code
          name_en
          name_ch
        }
        id
        last6run
        internationalRating
        currentRating 
        sire
        sexNm {
          chinese
          english
          code
        }
        age
        barrierDrawNumber
        gearInfo
        stat(type: $type) {
          statType
          numStarts
          numFirst
          numSecond
          numThird
        }
        damNm {
          code
          chinese
          english
        }
        sireOfDamNm {
          code
          chinese
          english
        }
        ownerNm {
          code
          chinese
          english
        }
        colorNm {
          code
          chinese
          english
        }
      }
    }
    date
    venueCode
  }

  simulcastHorse(ids: $ids, raceNumber: $raceNumber, meetingDate: $meetingDate, venCode: $venueCode) {
    id
    brandNumber
    earings
    performanceStats {
      type
      firstPlace
      secondPlace
      thirdPlace
      totalRun
      ssn
    }
  }
}
`;
export const GET_RACE_CARD_LIST_OLD = `
query RaceCardProfile($date: String, $venueCode: String, $type: STStatType, $ids: [String!], $raceNumber: String, $meetingDate: String) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    totalNumberOfRace
    status
    pmPools {
      leg {
        races
      }
      status
      oddsType
    }
    races {
      id
      no
      status
      postTime
      raceName_en
      raceName_ch
      raceResults {
        status
      }
      countryCodeNm {
        code
        english
        chinese
      }
      distance
      raceCourse {
        code
        description_en
        description_ch
      }
      raceTrack {
        code
        description_en
        description_ch
      }
      raceType_en
      raceType_ch
      raceClass_en
      raceClass_ch
      country_en
      country_ch
      winningMargin {
        seqNo
        lbw
      }
      go_en
      go_ch
      remarks {
        name_en
        name_ch
        seqNo
      }
      runners {
        horse {
          name_en
          name_ch
          id
        }
        status
        color
        no
        handicapWeight
        jockey {
          code
          name_en
          name_ch
        }
        trainer {
          code
          name_en
          name_ch
        }
        id
        last6run
        internationalRating
        currentRating 
        sire
        sexNm {
          chinese
          english
          code
        }
        age
        barrierDrawNumber
        gearInfo
        stat(type: $type) {
          statType
          numStarts
          numFirst
          numSecond
          numThird
        }
        damNm {
          code
          chinese
          english
        }
        sireOfDamNm {
          code
          chinese
          english
        }
        ownerNm {
          code
          chinese
          english
        }
        colorNm {
          code
          chinese
          english
        }
      }
    }
    date
    venueCode
  }

  simulcastHorse(ids: $ids, raceNumber: $raceNumber, meetingDate: $meetingDate, venCode: $venueCode) {
    id
    brandNumber
    earings
    performanceStats {
      type
      firstPlace
      secondPlace
      thirdPlace
      totalRun
      ssn
    } 
    horseFormRecord {
      videoReplayLink {
        chinese
        code
        english
      }
    }
  }
}
`;
export const GET_RACE_INFO_LIST = `
query SimulcastRaceInfo($ids: [String!], $raceNumber: String, $meetingDate: String, $venCode: String) {
  simulcastHorse(ids: $ids, raceNumber: $raceNumber, meetingDate: $meetingDate, venCode: $venCode) {
    id
    horseFormRecord {
      id
      date
      jockey {
        code
        name_ch
        name_en
      }
      trainer {
        name_ch
        name_en
      }
      raceNo
      placeNo
      ruPlace
      venue {
        code
        chinese
        english
      }
      track {
        english
        chinese
        code
      }
      gear
      comments {
        code
        chinese
        english
      }
      winners{
        pos
        name {
          chinese
          english
        }
        cnty {
          code
          chinese
          english
        }
      }
      med {
        code
        chinese
        english
      }
      raceName {
        code
        chinese
        english
      }
      course {
        code
        chinese
        english
      }
      raceId
      raceIndex
      runnerStatus
      racingComments {
        name
        date
      }
      winOdds
      resultIndex
      horseWeight
      actualWeight
      marginOrLBW {
        code
        chinese
        english
      }
      season
      runnerResults {
        id
      }
      racecourse {
        code
        chinese
        english
      }
      going {
        code
        chinese
        english
      }
      sectionTimeSplits {
        sectionTime
        gpSec
        sectionNo
      }
      raceTimeSplits {
        sectionNo
        gpSec
        sectionTime
      }
      sectionInfos {
        sectionNo
        ruPos
        sectionTime
      }
      barrierDrNo
      distance
      finalTimeOfRace
      raceCountry {
        code
        chinese
        english
      }
      cntyShortNm {
        code
        chinese
        english
      }
      racecourse {
        code
        chinese
        english
      }
      numOfStarters
      currency {
        english
        code
        chinese
      }
      ageCondition {
        code
        english
        chinese
      } 
      condition {
        code
        english
        chinese
      }
      prizeMoney
      fav
      placingRemarks
      className {
        chinese
        code
        english
      }
      raceTurn {
        chinese
        code
        english
      }
    }
    brandNumber
  }
}
`;
export const GET_HEADER_NAV_MAIN = `
    query SiteHeaderNavMain($path: String, $language: String) {
      item(path: $path, language: $language) {
        data: children {
          name
          hasChildren
          label: field(name: "label") {
            ... on TextField {
              value
            }
          }
          link: field(name: "link") {
            ... on TextField {
              value
            }
          }
          seq: field(name: "seq") {
            ... on TextField {
              value
            }
          }
          target: field(name: "newwindow") {
            ... on CheckboxField {
              value
            }
          }
          newwindow: field(name: "newwindow") {
            name
            value 
          }
          children {
            name
            hasChildren
            label: field(name: "label") {
              ... on TextField {
                value
              }
            }
            link: field(name: "link") {
              ... on TextField {
                value
              }
            }
            seq: field(name: "seq") {
              ... on TextField {
                value
              }
            }
            target: field(name: "newwindow") {
              ... on CheckboxField {
                value
              }
            }
            newwindow: field(name: "newwindow") {
              name
              value 
            }
            children {
              name
              hasChildren
              label: field(name: "label") {
                ... on TextField {
                  value
                }
              }
              link: field(name: "link") {
                ... on TextField {
                  value
                }
              }
              seq: field(name: "seq") {
                ... on TextField {
                  value
                }
              }
              target: field(name: "newwindow") {
                ... on CheckboxField {
                  value
                }
              }
              newwindow: field(name: "newwindow") {
                name
                value 
              }
              children {
                name
                hasChildren
                label: field(name: "label") {
                  ... on TextField {
                    value
                  }
                }
                link: field(name: "link") {
                  ... on TextField {
                    value
                  }
                }
                seq: field(name: "seq") {
                  ... on TextField {
                    value
                  }
                }
                target: field(name: "newwindow") {
                  ... on CheckboxField {
                    value
                  }
                }
                newwindow: field(name: "newwindow") {
                  name
                  value 
                }
              }
            }
          }
        }
      }
    }
    `;

export const GET_HEADER = `
    query SiteHeader($path: String, $language: String) {
      item(path: $path, language: $language) {
        displayName
        HRLabel: field(name: "HRLabel") {
          value
        }
        LeftImage: field(name: "LeftImage") {
          ... on ImageField {
            value
            size
            src
            title
          }
        }
        RightImage: field(name: "RightImage") {
          ... on ImageField {
            value
            size
            src
            title
            alt
          }
        }
        HRRedirectionLink: field(name: "HRRedirectionLink") {
          value
        }
        LeftLink: field(name: "LeftLink") {
          value
        }
        RightLink: field(name: "RightLink") {
          value
        }
        HRRedirectionNewWindow: field(name: "HRRedirectionNewWindow") {
          value
        }
        LeftLinkNewWindow: field(name: "LeftLinkNewWindow") {
          value
        }
        RightLinkNewWindow: field(name: "RightLinkNewWindow") {
          value
        }
        FBLabel: field(name: "FBLabel") {
          value
        }
        FBRedirectionLink: field(name: "FBRedirectionLink") {
          value
        }
        FBRedirectionNewWindow: field(name: "FBRedirectionNewWindow") {
          value
        }
        M6Label: field(name: "M6Label") {
          value
        }
        M6RedirectionLink: field(name: "M6RedirectionLink") {
          value
        }
        M6RedirectionNewWindow: field(name: "M6RedirectionNewWindow") {
          value
        }
      }
    } 
    `;

export const GET_RACE_SITE_MENU = `
  query SiteRacingMenu($path: String, $language: String) {
    item(path: $path, language: $language) {
      children {
        name
        hasChildren
        label: field(name: "Label") {
          ... on TextField {
            value
          }
        }
        link: field(name: "RedirectionURL") {
          ... on TextField {
            value
          }
        }
        target: field(name: "Target") {
          ... on TextField {
            value
          }
        }
        targetJCRWPage: field(name: "RedirectionJCRWPage") {
          ... on TextField {
            value
          }
        }
        redirectionTarget: field(name: "Redirection") {
          ... on TextField {
            value
          }
        }
        children {
          name
          hasChildren
          label: field(name: "Label") {
            ... on TextField {
              value
            }
          }
          link: field(name: "RedirectionURL") {
            ... on TextField {
              value
            }
          }
          target: field(name: "Target") {
            ... on TextField {
              value
            }
          }
          targetJCRWPage: field(name: "RedirectionJCRWPage") {
            ... on TextField {
              value
            }
          }
          redirectionTarget: field(name: "Redirection") {
            ... on TextField {
              value
            }
          }
          children {
            name
            hasChildren
            label: field(name: "Label") {
              ... on TextField {
                value
              }
            }
            link: field(name: "RedirectionURL") {
              ... on TextField {
                value
              }
            }
            target: field(name: "Target") {
              ... on TextField {
                value
              }
            }
            targetJCRWPage: field(name: "RedirectionJCRWPage") {
              ... on TextField {
                value
              }
            }
            redirectionTarget: field(name: "Redirection") {
              ... on TextField {
                value
              }
            }
            children {
              name
              hasChildren
              label: field(name: "Label") {
                ... on TextField {
                  value
                }
              }
              link: field(name: "RedirectionURL") {
                ... on TextField {
                  value
                }
              }
              target: field(name: "Target") {
                ... on TextField {
                  value
                }
              }
              targetJCRWPage: field(name: "RedirectionJCRWPage") {
                ... on TextField {
                  value
                }
              }
              redirectionTarget: field(name: "Redirection") {
                ... on TextField {
                  value
                }
              }
            }
          }
        }
      }
    }
  } 
`;

export const GET_RACE_MEETING_PROFILE = `
  query RaceMeetingProfile($date: String, $oddsTypes: [OddsType], $venueCode: String) {
    raceMeetingProfile(date: $date, venueCode: $venueCode) {
      races {
        runners {
          jockey {
            id
            code
            name_en
            name_ch
            status
          }
          trainer {
            id
            code
            name_en
            name_ch
          }
          horse {
            name_en
            name_ch
            id
          }
          id
          no
          winOdds
          status
        }
        distance
        raceClass_en
        raceClass_ch
        no
        raceTrack {
          code
          description_en
          description_ch
        }
        id
        raceName_en
        raceName_ch
        status
      }
      venueCode
      date
      status
      pmPools(oddsTypes: $oddsTypes) {
        status
        sellStatus 
        id 
        leg {
          number
          races
        }
        oddsNodes {
          oddsValue 
          combString
          hotFavourite
        }
      }
      changeHistories {
        type
        raceNo
        runnerNo
      }
    } 
  }
`;

export const GET_FOOTER_MENU = `
  query FooterMenu($language: String, $path: String) { 
    item(language: $language, path: $path) {
      sitemap: field(name: "Sitemap") {
        ... on TextField {
          value
        }
      } 
      bottomlink: field(name: "BottomLink") {
        ... on TextField {
          value
        }
      }
    }
  } 
  `;

export const GET_RGPBanner = `  
  query RGPBanner($language: String, $path: String) { 
    item(language: $language, path: $path) {
      RGPBanner: field(name: "RGPBanner") {
        ... on TextField {
          rendered 
        }
      }
    }
  } 
  `;

export const GET_SELECTED_MEETING_RACES_INFO = `
  query SelectedMeetingRacingInfo($language: String, $path: String, $entriesFolderTemplateIDs: [String]) {
    item (language: $language, path: $path){
      displayName
      hasChildren
      races: children {
        id
        displayName
        hasChildren        
        ... on Race {
          raceName {
            value
          }
          venueCode {
            value
          }
          raceDatetime {
            value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
          }
          raceDistance {
            value
          }
          group {
            value
          }
          trackMap {
            targetItem {
              ... on TrackImage {
                trackImage {
                  src
                  alt
                }
              }
            }
          }
          raceDescription {
            value
          }
        }
        entries: children (includeTemplateIDs: $entriesFolderTemplateIDs) {
          displayName
          hasChildren     
          ... on Entries {
            entries {
              value
            }
          }
        }
      }
    }
  }
  `;

export const GET_SIMPLIFIED_MEETING_RACES_INFO = `
  query SimpifedMeetingRacingInfo($language: String, $path: String) {
    item(language: $language, path: $path) {
      displayName
      hasChildren
      races: children {
        displayName
        hasChildren
        ... on Race {
          venueCode {
            value
          }
          raceDistance {
            value
          }
          group {
            value
          }
        }
      }
    }
  }
`;


export const SEARCH_MEETINGS_BY_DATE = `
fragment menuInfo on MeetingSummaryMenu {
  displayName
  name
  hasChildren
  label {
    value
    name
  }
  redirection {
    value
  }
  redirectionJCRWPage {
    value
  }
  redirectionURL {
    value
  }
  target {
    value
  }
}

fragment meetingSummaryMenu on MeetingSummaryMenu {
  ...menuInfo
  children{
    ...menuInfo
    children {
    ...menuInfo
    }
  }
}

query SearchMeetingsByDate($path: String!, $language: String!, $meetingDate: String!) {
  engSearch: search(
    rootItem: $path
    language: "en-us"
    fieldsEqual: [{ name: "MeetingDate", value: $meetingDate }]
  ) {
    results {
      items {
        meeting: item {
          ... on MeetingDate {
            id
            meetingCountry {
              value
            }
            countryName {
              value
            }
          }
        }
      }
    }
  }
  search(
    rootItem: $path, 
    language: $language,
    fieldsEqual: [{name: "MeetingDate", value: $meetingDate}]
    ) {
    results {
      items {
        meeting: item {
          ... on MeetingDate {
            id
            name
            displayName
            hasChildren
            path
            season: parent {
              name
            }
            presite {
              boolValue
            }
            meetingDate {
              value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
            }
            meetingVenueCode {
              value
            }
            meetingCountry {
              value
            }
            countryName {
              value
            }
            racedayName {
              value
              rendered
            }
            racedayImage {
              alt
              src
            }
            carnivalInfo {
              value
            }
            racecourseName {
              value
            }
            noOfRaces {
              value
            }
            mainRace {
              targetItem {
                displayName
                path
                template {
                  id
                }
              }
            }
            meetingDescription {
              value
              rendered
            }
            MeetingSummaryMenu: meetingSummaryMenu {
              targetItems {
                ...meetingSummaryMenu
              }
            }
            RaceImages: raceImages {
              targetItems {
                ... on RaceImage {
                  RaceimageURL: raceimage {
                    src
                    alt
                  }
                }
              } 
            }
            finalDeclarationsAndBarrierDraws {
              displayName
              rendered
              value
              url
            }
          }
        }
      }
      totalCount
    }
  }
}
`;

export const GET_MEETING_BROADCAST = ` 
query MeetingBroadcast($path: String, $language: String) {
  items: item(path: $path, language: $language) {
    remarks: field(name: "remarks") {
      value
    }
    content:children {
     ... on BroadcastTable {
      title {
        value
      }
     }
     broadcasts: children {
        ... on BroadcastRow {
          displayName
          broadcastTime {
            value
          }
          channels {
            value
          }
          languages {
            value
          }
          reserved1 {
            value
          }
          reserved2 {
            value
          }
          reserved3 {
            value
          }
        }
      }
    }
  }
}
`;

export const GET_MEETING_BROADCASTCONFIG = ` 
query MeetingBroadcastConfig($path: String, $language: String) {  
  config: item(path: $path, language: $language) {
    ... on BroadcastConfig {
      displayName
      title {
        value
      }
      enableBroadcastTime {
        value: boolValue
      }
      enableChannels {
        value: boolValue
      }
      enableLanguages {
        value: boolValue
      }
      enableReserved1 {
        value: boolValue
      }
      enableReserved2 {
        value: boolValue
      }
      enableReserved3 {
        value: boolValue
      }
    }
  }
}
`;

export const GET_RACE_PASTWINNERS = ` 
query PastWinners($path: String, $language: String) {
  data: item(path: $path, language: $language) {
    pastWinners: children{
      ... on PastWinner {
        year {
          value
        }
        horse {
          value
        }
        jockey {
          value
        }
        trainer {
          value
        }
        replayVideo {
          value
        }
      }
    }
  }
  config: item(path: "/sitecore/content/Sites/JCRW/Simulcast/PastWinnersConfig", language: $language) {
    ... on PassWinnersConfig {
      displayName
      label1 {
        value
      }
      label2 {
        value
      }
      label3 {
        value
      }
      label4 {
        value
      }
      label5 {
        value
      }
      enabled1 {
        value
      }
      enabled2 {
        value
      }
      enabled3 {
        value
      }
      enabled4 {
        value
      }
      enabled5 {
        value
      }
      isVideo1 {
        value
      }
      isVideo2 {
        value
      }
      isVideo3 {
        value
      }
      isVideo4 {
        value
      }
      isVideo5 {
        value
      }
    }
    
  }
}
`;

export const GET_HORSE_PROFILE = `
query SimulcastHorseProfile($ids: [String!], $meetingDate: String, $raceNumber: String) {
  simulcastHorse(ids: $ids, meetingDate: $meetingDate, raceNumber: $raceNumber) {
    age
    brandNumber
    earings
    colour {
      code
      chinese
      english
    }
    dam
    countryOfOrigin {
      chinese
      code
      english
    }
    sire
    sireOfDam
    rating
    name_ch
    name_en
    gender {
      chinese
      code
      english
    }
    id
    trainer {
      name_ch
      name_en
    }
    ownerName {
      chinese
      code
      english
    }
    winningRecord {
      totalStakes
      firstPlace
      secondPlace
      thirdPlace
      totalRun
    }
    performanceStats {
      type
      firstPlace
      secondPlace
      thirdPlace
      totalRun
      ssn
    }
    horseFormRecord {
      id
    }  
  }
}
`;
export const GET_HORSE_PERFORMANCE = `
query SimulcastHorse_Performance($raceNumber: String, $meetingDate: String, $ids: [String!]) {
  simulcastHorse(raceNumber: $raceNumber, meetingDate: $meetingDate, ids: $ids) {
    performanceStats {
      type
      firstPlace
      secondPlace
      thirdPlace
      totalRun
      ssn
    }  
    earings
  }
}
`;

export const GET_RACE_RESULTS_LIST = `
    query RaceResultsProfile($date: String, $venueCode: String) {
      videoReplay(date: $date, venueCode: $venueCode) {
        hkRaceDate
        raceNo
        overseasRaceIndicator
        videoPresentOrNot
        isVideoReplayOn
        language
      }
      raceMeetingProfile(date: $date, venueCode: $venueCode) {
        totalNumberOfRace
        currentNumberOfRace
        races {
          id
          no
          status
          runners {
            horse {
              id
              name_en
              name_ch
            }
            color
            id
            no
            handicapWeight
            jockey {
              code
              name_en
              name_ch
            }
            trainer {
              code
              name_en
              name_ch
            }
            last6run
            internationalRating
            sire
            sexNm {
              chinese
              english
            }
            age
            barrierDrawNumber
            gearInfo
            margin
            marginNm {
              chinese
              english
            }
            lbwNm {
              chinese
              english
            }
            winOdds
            finalPosition
            deadHeat
            status
          }
          judgeSigns {
            value_en
          }
          raceName_en
          raceName_ch
          postTime
          country_en
          country_ch
          distance
          go_en
          go_ch
          raceTrack {
            description_en
            description_ch
          }
          raceCourse {
            description_en
            description_ch
            displayCode
          }
          raceClass_en
          raceClass_ch
          raceResults {
            status
            raceTime
            mgnInd
          }
        }
        date
        venueCode
        pmPools {
          leg {
            number
            races
          }
          status
          comingleStatus
          oddsType
          name_en
          name_ch
          lastUpdateTime
          dividends(officialOnly: true) {
            winComb
            type
            div
            seq
            status
            guarantee
            partial
            partialUnit
          }
        }
        status
      }
    }
    `;

export const GET_FIXTURELIST_SUMMARY = `
fragment MeetingData on MeetingDate {
  hasChildren
  path
  presite {
    boolValue
  }
  meetingDate {
    value: formattedDateValue(
      format: "yyyy-MM-ddTHH:mm:sszzz"
      offset: -480
    )
  }
  meetingVenueCode {
    value
  }
  mainRace {
    targetItem {
      displayName
      path
      template {
        id
      }
    }
  }
  races: children(
    includeTemplateIDs: $racesFolderTemplateIDs
  ) {
    raceInfo: children {
      ... on Race {
        displayName
        raceDatetime {
          value: formattedDateValue(
            format: "yyyy-MM-ddTHH:mm:sszzz"
            offset: -480
          )
        }
      }
    }
  }
}

query FixtureListSummary($path: String, $language: String, $racesFolderTemplateIDs: [String]) { 
  data: item(path: $path, language: $language) {
    season: children {
      displayName
      hasChildren
      ... on FixtureSeasonFolder {
        fixtureSorting {
          targetItems {
            ... on Fixture {
              meetingRaceMapping {
                targetItem {
                  displayName
                  template {
                    name
                  }
                  ...MeetingData
                  ... on Race {
                    raceDatetime {
                      value: formattedDateValue(
                        format: "yyyy-MM-ddTHH:mm:sszzz"
                        offset: -480
                      )
                    }
                    parent {
                      meeting: parent {
                        displayName
                        ...MeetingData
                      }
                    }
                  }
                }
              }
              date_HK {
                value: rendered
              }
              raceName {
                value
              }
              locationName {
                value
              }
              locationCode {
                value
              }
              locationNameList: versions(allLanguages: true) {
                version
                language {
                  name
                }
                ... on Fixture {
                  locationName {
                    value
                  }
                }
              }
              raceSeries: field(name: "raceSeries") {
                ... on MultilistField {
                  targetItems {
                    displayName
                    label: field(name: "raceSeries") {
                      value
                    }
                  }
                }
              }
              teamsiteURL {
                value
              }
            }
          }
        }
        currentSeason {
          boolValue
        }
      }
    }
  }
  config: item(
    path: "/sitecore/content/Sites/JCRW/Simulcast/FixtureConfig_MeetingSummary"
    language: $language
  ) {
    ... on FixtureConfig_MeetingSummary {
      date_HK {
        value
      }
      time {
        value
      }
      raceday_Race {
        value
      }
      country {
        value
      }
    }
  }
}`;

export const GET_FIXTURELIST = `
fragment MeetingData on MeetingDate {
  hasChildren
  path
  presite {
    boolValue
  }
  meetingDate {
    value: formattedDateValue(
      format: "yyyy-MM-ddTHH:mm:sszzz"
      offset: -480
    )
  }
  meetingVenueCode {
    value
  }
  mainRace {
    targetItem {
      displayName
      path
      template {
        id
      }
    }
  }
  races: children(
    includeTemplateIDs: $racesFolderTemplateIDs
  ) {
    raceInfo: children {
      ... on Race {
        displayName
        raceDatetime {
          value: formattedDateValue(
            format: "yyyy-MM-ddTHH:mm:sszzz"
            offset: -480
          )
        }
      }
    }
  }
}

query FixtureList($path: String, $language: String, $racesFolderTemplateIDs: [String]) {  
  data: item(path: $path, language: $language) {
    season: children {
      displayName
      hasChildren
      ... on FixtureSeasonFolder {
        fixtureSorting {
          targetItems {
            ... on Fixture {
              carnivalName {
                value
              }
              meetingRaceMapping {
                targetItem {
                  displayName
                  template {
                    name
                  }
                  ...MeetingData
                  ... on Race {
                    raceDatetime {
                      value: formattedDateValue(
                        format: "yyyy-MM-ddTHH:mm:sszzz"
                        offset: -480
                      )
                    }
                    parent {
                      meeting: parent {
                        displayName
                        ...MeetingData
                      }
                    }
                  }
                }
              }
              date_HK {
                value: rendered
              }
              raceName {
                value
              }
              locationName {
                value
              }
              locationCode {
                value
              }
              locationNameList: versions(allLanguages: true) {
                version
                language {
                  name
                }
                ... on Fixture {
                  locationName {
                    value
                  }
                }
              }
              raceSeries: field(name: "raceSeries") {
                ... on MultilistField {
                  targetItems {
                    displayName
                    label: field(name: "raceSeries") {
                      value
                    }
                  }
                }
              }
              teamsiteURL {
                value
              }
            }
          }
        }
        currentSeason {
          boolValue
        }
      }
    }
  }
  config: item(
    path: "/sitecore/content/Sites/JCRW/Simulcast/FixtureConfig_FixtureList"
    language: $language
  ) {
    ... on FixtureConfig_FixtureList {
      date_HK {
        value
      }
      raceName {
        value
      }
      location {
        value
      }
      raceSeries1 {
        value
      }
      raceSeries2 {
        value
      }
      raceSeries3 {
        value
      }
    }
  }
}`;
export const GET_WINODDS_INFO = `
query RacesWinOdds($date: String, $venueCode: String, $oddsTypes: [OddsType]) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    races {
      no
      status
      runners {
        no
        status
      } 
    }
    pmPools(oddsTypes: $oddsTypes) {
      id
      oddsNodes {
        combString
        hotFavourite
        oddsValue
      }
      lastUpdateTime
    }
  }
}
`;
export const GET_REFERENCEODDS_INFO = `
query ReferenceOdds($path: String, $language: String) {
  item(path: $path, language: $language) {
    ... on ReferenceOdds {
      ReferenceOddsTimestamp: referenceOddsTimestamp {
        value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
      }
      referenceOdds {
        
        value
      }
    }
  }
}
`;
export const GET_FORMCOMMENTS = `
query FormComments($path: String, $language: String) {
  item(path: $path, language: $language) {
      children {
        ... on FormComments {
        content {
          value
        }
      } 
    }
    ... on Race{
      raceName {
        value
      }
      raceDatetime {
        value
      }
      venueCode {
        value
      }
    }
  }
}
`;
export const GET_FORMTITLE = `
query RacesFormTitle($date: String, $venueCode: String) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    races {
      id
      raceName_en
      raceName_ch
      postTime
      no
    }
  }
}
`;


export const GET_DISCLAIMER = `
  query Disclaimer($path: String, $language: String) {
    item: item(
      path: $path,
      language: $language
    ){
      disclaimer:field(name:"disclaimer"){
            value
          }
    }
  }
  `;

export const GET_TRACK_ANALYSIS = `
query TrackAnalysis($path: String, $language: String) {
    item: item(
      path: $path,
      language: $language
    ){
    ... on TrackAnalysis {
      title {
        value
      }
      videoLink {
        value
      }
      videoThumbnail {
        src
      }
      videoTitle {
        value
      }
      description {
        value
      }
      expertSelection {
        value
      }
      trackMap {
        targetItem {
          ... on TrackImage {
            trackImage {
              src
              alt
            }
          }
        }
      }
    }
  }
}
`;

export const GET_TRACK_ANALYSIS_EXPERTS = `
query TrackAnalysisExperts($path: String, $language: String) {
  item: item(path: $path, language: $language) {
    expertName: field(name: "expertName") {
      value
    }
    expertIntroduction: field(name: "expertIntroduction") {
      value
    }
    expertPicture: field(name: "expertPicture") {
      ... on ImageField {
        src
        alt
      }
    }
  }

  enItem: item(path: $path, language: "en-us") {
    expertName: field(name: "expertName") {
      value
    }
  }
}
`;

export const GET_BANNERS = `
query BannerQuery($path:String,$language:String){
  banners:item(path:$path,language:$language){
    bannerList:children{
      imageUrl:field(name:"Banner"){
        ... on ImageField{
          value:src
        }
      }
      imageUrl_Mobile:field(name:"MobileBanner"){
        ... on ImageField{
          value:src
        }
      }
      redirectionLink:field(name:"RedirectionLink"){
        value
      }
      target:field(name:"Target"){
        value
      }
      desktopEnable :field(name:"DesktopEnable"){
        ... on CheckboxField{
          value:boolValue
        }
      }
      mobileEnable :field(name:"MobileEnable"){
        ... on CheckboxField{
          value:boolValue
        }
      }
      description: field(name:"BannerDescription"){
        value
      }
      onlineDatetime:field(name:"OnlineDatetime"){
        sourceDate:value
        ...on DateField{
          value:formattedDateValue(format:"s",offset:-480)
        }
      }
      OfflineDatetime:field(name:"OfflineDatetime"){
        sourceDate:value
        ...on DateField{
          value:formattedDateValue(format:"s",offset:-480)
        }
      }
    }
  }
}
`;

export const GET_TIMEOFFSET = `
query TimeOffset {
  timeOffset {
    ts
    fb
    rc
    m6
  }
}
`;

export const GET_MEETING_SUMMARY_MENU_TYPE = `
query SimulcastMeetingMenuType($path: String, $language: String) {
  item(path: $path, language: $language) {
    menus: children {
      displayName
      subMenus: children {
      displayName
      }
    }
  }
}
`;

export const GET_SEASON_BY_DATE = `
query GetSeasonByDate ($path: String!, $dateStr: String!, $limit: Int!, $language: String!) {
  search(
    rootItem: $path,    
    fieldsEqual:[
      { name:"MeetingDate", value: $dateStr }
    ],
    after: "0",
    first: $limit,
    language: $language,
  ) {
    results {
      items {
        name
        path
        language
      }
      totalCount
    }
  }
}
`;

export const GET_JOCKEYSTRAINERSRANKING = `
query JockeysTrainersRanking($path: String, $language: String) {
  item(path: $path, language: $language) {
    displayName
    name
    hasChildren
    children {
      name
      displayName
      location: field(name: "Location"){
        value
      }  
      jockeysRanking: field(name: "JockeysRanking"){
        value
      } 
      jockeysSourceLastUpdated: field(name: "JockeysSourceLastUpdated"){
        value
      } 
      trainersSourceLastUpdated: field(name: "TrainersSourceLastUpdated"){
        value
      }
      trainersRanking: field(name: "TrainersRanking"){
        value
      } 
    }
  }
}
`;

export const GET_MEETING_STATUS = `
query SIM_MeetingStatus($date: String, $venueCode: String, $oddsTypes: [OddsType]) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    totalNumberOfRace
    currentNumberOfRace
    date
    venueCode
    status
    races {
      no
      postTime
      status
      raceResults {
        status
      }
      go_ch
      go_en
      goCode
      raceTrack {
        code
        description_ch
        description_en
      }
      countryCodeNm {
        chinese
        code
        english
      }
    }
    pmPools(oddsTypes: $oddsTypes) {
      oddsType
      status
      leg {
        races
      }
    }
  }
}
`;

export const GET_MEETINGRACE_NEWS = `
query GetMeetingRaceNews(
  $language: String
  $path: String
  $fieldid: String!
  $offset: Int
) {
  search(
    language: $language
    rootItem: $path
    fieldsEqual: [{ name: "simulcastmeetingrace", value: $fieldid }]
  ) {
    results {
      items {
        item {
          displayName
          ... on News {
            publishDateTime: field(name: "datetime") {
              ... on DateField {
                date: formattedDateValue(format: "dd/MM", offset: $offset)
                time: formattedDateValue(format: "HH:mm", offset: $offset)
                value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
              }
            }
            title {
              value
            }
            target{
              value
            }
            url: newsURL{
              value
            }
          }
        }
      }
    }
  }
}
`;

export const GET_RACING_CHANGES = `
query racingChanges($date: String, $venueCode: String) {
  raceMeetingProfile(date: $date, venueCode: $venueCode)
  {
      id
      venueCode
      date
      races {
        no
        runners {
          id
          no
        }
      }
      changeHistories {
        type
        time
        raceNo
        runnerNo
        horseName_ch
        horseName_en
        jockeyName_ch
        jockeyName_en
        scratchHorseName_ch
        scratchHorseName_en
        handicapWeight
        scrResvIndicator
        horseCode
      }
  }
}
`;
export const GET_GEARINFO = `
query GearInfo($path: String, $language: String) {
  item(path: $path, language: $language) {
    displayName 
    children { 
      gearCode: field(name: "GearCode") {
        value
      }
      gearName: field(name: "GearName") {
        value
      }
    }
  }
}
`;

export const GET_HOME_BASIC_INFO = `
query getHomeBasicInfo($localSim: LocalSim, $meetingsOnly: Boolean!, $oddsTypes: [OddsType]) {
  commonMeetings(localSim: $localSim) {
    id
    venueCode
    date
    status
    season
    totalNumberOfRace
    currentNumberOfRace
    races {
      no
      postTime
      status
      raceResults {
        status
      }
    }
    pmPools(oddsTypes: $oddsTypes) {
      oddsType
      status
      leg {
        races
      }
    }
  }
  racingSeasonPeriod(locSim: $localSim) @skip(if: $meetingsOnly) {
    code
    endDate
    nature
    startDate
  }
}
`;

export const SEARCH_MEETINGS_IN_DATE_RANGE = `
query SearchMeetingsInDateRange($path: String, $language: String, $fieldsEqual: [ItemSearchFieldQuery], $from: String, $to: String, $racesFolderTemplateIDs: [String]) {
  extendedSearch(
    fieldsEqual: $fieldsEqual,
    rootItem: $path, 
    language: $language,
    dateFrom: $from,
    dateTo: $to,
    fieldName: "MeetingDate",
    sortBy: "MeetingDate",
    sortDesc: false,
    ) {
    results {
      items {
        meeting: item {
          ... on MeetingDate {
            id
            name
            path
            displayName
            hasChildren
            season: parent {
              name
            }
            presite {
              boolValue
            }
            meetingDate {
              date: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
              value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
            }
            meetingVenueCode {
              value
            }
            mainRace {
              targetItem {
                displayName
                path
                template {
                  id
                }
              }
            }
            races: children(
              includeTemplateIDs: $racesFolderTemplateIDs
            ) {
              raceInfo: children {
                displayName
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
`;

export const GET_OVERRIDE_REDIRECTION_CONFIG = `
query GetOverrideRedirectionConfig($path: String, $language: String, $racesFolderTemplateIDs: [String]) {
  overrideConfig: item(path: $path,language: $language){
    ... on OverrideRedirectionConfig {
      enable {
        boolValue
      }
      offlineDateTime {
        value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
      }
      onlineDateTime {
        value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
      }
      redirectTo {
        targetItem {
          displayName
          template {
            id
            name
          }
          ... on MeetingDate {
            hasChildren
            path
            presite {
              boolValue
            }
            meetingDate {
              date: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
              value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
            }
            meetingVenueCode {
              value
            }
            mainRace {
              targetItem {
                displayName
                path
                template {
                  id
                }
              }
            }
            races: children(
              includeTemplateIDs: $racesFolderTemplateIDs
            ) {
              raceInfo: children {
                displayName
              }
            }
          }          
          ... on Race {
            parent {
              meeting: parent {
                displayName
                ... on MeetingDate {
                  hasChildren
                  path
                  presite {
                    boolValue
                  }
                  meetingDate {
                    date: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
                    value: formattedDateValue(format: "yyyy-MM-ddTHH:mm:sszzz", offset: -480)
                  }
                  meetingVenueCode {
                    value
                  }
                }
              }
            }
          }
        }        
      }
    }
  }
}
`;

export const GET_MEETING_GENERAL_INFORMATION = `
query GetPmPools($date: String, $venueCode: String, $oddsTypes: [OddsType]) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    races {
      no
      postTime
    }
    pmPools(oddsTypes: $oddsTypes) {
      oddsType
      estimatedDividend
      comingleStatus
      jackpot
      leg {
        number
        races
      }
    }
  }
}
`;
export const GET_RACE_CARD_COLUMNS = `
query GetRaceCardColumnConfig($path: String, $language: String) {
  raceCardColumns: item(path: $path,language: $language){
    children{
      tabLabel: field(name:"tabLabel"){
        value
      }
       columns: field(name:"Columns"){
        ... on MultilistField{
          targetItems{
            Option_Name: field(name:"Option_Name"){
              value
            }
            displayName
          }
        }
      }
    }
  }
}
`;

export const GET_EXPERTCOLUMN = ` 
query ExpertColumn($path: String, $language: String) {
  item(path: $path, language: $language) {
    displayName 
    expert: field(name: "Expert") {
      name
      value
    } 
    horseNumber01: field(name: "HorseNumber01") {
      name
      value
    }
    horseName01: field(name: "HorseName01") {
      name
      value
    }
    horseNumber02: field(name: "HorseNumber02") {
      name
      value
    }
    horseName02: field(name: "HorseName02") {
      name
      value
    }
    horseNumber03: field(name: "HorseNumber03") {
      name
      value
    }
    horseName03: field(name: "HorseName03") {
      name
      value
    }
    horseNumber04: field(name: "HorseNumber04") {
      name
      value
    }
    horseName04: field(name: "HorseName04") {
      name
      value
    }
    horseNumber05: field(name: "HorseNumber05") {
      name
      value
    }
    horseName05: field(name: "HorseName05") {
      name
      value
    }
    horseNumber06: field(name: "HorseNumber06") {
      name
      value
    }
    horseName06: field(name: "HorseName06") {
      name
      value
    }
    horseNumber07: field(name: "HorseNumber07") {
      name
      value
    }
    horseName07: field(name: "HorseName07") {
      name
      value
    }
    horseNumber08: field(name: "HorseNumber08") {
      name
      value
    }
    horseName08: field(name: "HorseName08") {
      name
      value
    }
    horseNumber09: field(name: "HorseNumber09") {
      name
      value
    }
    horseName09: field(name: "HorseName09") {
      name
      value
    }
    horseNumber10: field(name: "HorseNumber10") {
      name
      value
    }
    horseName10: field(name: "HorseName10") {
      name
      value
    }
    commentary: field(name: "Commentary") {
      name
      value
    }
    betSelectionName01: field(name: "BetSelectionName01") {
      name
      value
    }
    selectionLinkParameters01: field(name: "SelectionLinkParameters01") {
      name
      value
    }
    betSelectionDetails01: field(name: "BetSelectionDetails01") {
      name
      value
    }
    betSelectionName02: field(name: "BetSelectionName02") {
      name
      value
    }
    selectionLinkParameters02: field(name: "SelectionLinkParameters02") {
      name
      value
    }
    betSelectionDetails02: field(name: "BetSelectionDetails02") {
      name
      value
    }
    betSelectionName03: field(name: "BetSelectionName03") {
      name
      value
    }
    selectionLinkParameters03: field(name: "SelectionLinkParameters03") {
      name
      value
    }
    betSelectionDetails03: field(name: "BetSelectionDetails03") {
      name
      value
    }
    betslipLink01: field(name: "betslipLink01") {
      rendered
    }
    betslipLink02: field(name: "betslipLink02") {
      rendered
    }
    betslipLink03: field(name: "betslipLink03") {
      rendered
    }
  }
}
`;

export const GET_HORSE_MEETINGRACE = `
query HorseByMeetingRace($meetingDate: String, $raceNumber: String, $venCode: String, $ids: [String!]) {
  simulcastHorse(meetingDate: $meetingDate, raceNumber: $raceNumber, venCode: $venCode, ids: $ids) {
    id
    brandNumber
    name_ch
    name_en
  }
}
`;

export const GET_TIPSTERS_SELECTION = `
query TipstersSelections($path: String, $language: String) {
  item(path: $path, language: $language) {
    races: children {
      ... on TipstersSelectionTable {
        race {
          information: targetItem {
            ... on Race {
              name: raceName {
                value
              }
              raceNo: venueCode {
                value
              }
            }
          }
        }
        selections: children {
          selection: field(name: "Content") {
            value
          }
        }
      }
    }
  }
}
`; 

export const GET_MEETING_PM_POOL_STATUS = `
query SIM_GetMeetingPmPoolStatus($date: String, $venueCode: String, $oddsTypes: [OddsType]) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    venueCode
    pmPools(oddsTypes: $oddsTypes) {
      oddsType
      sellStatus
      status
      leg {
        races
      }
    }
  }
}
`; 

export const GET_INPAGEDISPLAYBUTTONS = `
fragment templateName on Item {
  template {
    name
  }
}
query GetInPageDisplayButtons(
  $path: String
  $path_SpeedMap: String
  $path_DefaultButtonsMap: String
  $language: String
) {
  item(path: $path, language: $language) {
    buttons: children {
      name
      ... on JockeysTrainersRankings {
        versions {
          version
        }
      }
      ... on RacingStatistics {
        versions {
          version
        }
      }
      ... on TipstersSelections {
        versions {
          version
        }
      }
      ... on TrackAnalysis {
        versions {
          version
        }
      }
      ...templateName
      children {
        name
        ...templateName
        displayName: field(name: "Label") {
          value
        }
        ... on URLButton {
          URLLink: field(name: "URLLink") {
            value
          }
          target: field(name: "Target") {
            value
          }
        }
        ... on PDFButton {
          PDFLink: field(name: "PDF") {
            ... on FileField {
              url
            }
          }
        }
        ... on SinglePhotoButton {
          singlePhoto: field(name: "Photo") {
            ... on ImageField {
              src
              width
              height
            }
          }

          captionTitle: field(name: "Caption Title") {
            value
          }
          captionContent: field(name: "Caption Content") {
            value
          }
        }

        selectedRaceInRoot: field(name: "Race") {
          ... on MultilistField {
            targetItems {
              name
              path
              template {
                id
              }
            }
          }
        }
        ... on TipstersSelectionTable {
          selectedRaceTipstersSelections: field(name: "Race") {
            ... on ReferenceField {
              targetItem {
                name
                path
                template {
                  id
                }
              }
            }
          }
        }
        children {
          name
          ... on ExpertColumn {
            versions {
              version
            }
          }
          ... on FormComments {
            versions {
              version
            }
          }
          ...templateName
          ... on MultiplePhotoItem {
            photo: field(name: "Photo") {
              ... on ImageField {
                src
                width
                height
              }
            }
            captionTitle: field(name: "Caption Title") {
              value
            }
            captionContent: field(name: "Caption Content") {
              value
            }
          }
          ... on VideoItem {
            videoTitle: field(name: "Title") {
              value
            }
            videoThumbnail: field(name: "Thumbnail") {
              ... on ImageField {
                src
              }
            }
            videoURL: field(name: "URL") {
              value
            }
          }
          selectedRace: field(name: "Race") {
            ... on MultilistField {
              targetItems {
                name
                path
                template {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
  speedMapItem: item(path: $path_SpeedMap, language: $language) {
    name
    url
    width: field(name: "width") {
      value
    }
    height: field(name: "height") {
      value
    }
  }
  defaultButtons: item(path: $path_DefaultButtonsMap, language: $language) {
    buttons: children {
      name
      template {
        name
      }
      displayName: field(name: "Label") {
        value
      }
      redirectionLink: field(name: "RedirectionLink") {
        value
      }
    }
  }
}

`; 

export const GET_ARTICLE = `
query Article($path: String, $language: String) {
  item: item(path: $path, language: $language) {
    ... on ArticleButton {
      Article: children {
        id
        name
      	title: field(name: "Title") {
          value
        }
        description: field(name: "Description") {
          value
          rendered
        }
        imageUrl: field(name: "Image") {
          ... on ImageField {
            src
          }
        }
        race: field(name: "Race") {
          ... on MultilistField {
            targetItems {
              displayName
            }
          }
        }
      }
    }
  }
}
`; 

export const GET_CARNIVALS = ` 
query Carnivals($path: String, $language: String) {
  item(path: $path, language: $language) { 
    carnivals: children {
      displayName
      ... on CarnivalPage{
        carnivalName: field(name: "carnivalName") {
          value
        } 
        raceDate: field(name: "raceDate") {
          ... on DateField {
            value: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
          }
          value
        } 
        racecourseName: field(name: "racecourseName") {
          value
        }   
      }
      carnivalTab: children {
        displayName
        ... on CarnivalTab{
          tabLabel: field(name: "TabLabel") {
            value
          } 
        }
        carnivalSection: children {
          displayName 
          template {
            name
          }
          ... on CarnivalA{
            title: field(name: "Title") {
              value
            } 
            image: field(name: "Image") {
              ... on ImageField {
                src
              } 
            }
            content: field(name: "Content") {
              value
            }
            externalLink: field(name: "ExternalLink") {
              value
            }
          } 

          ... on CarnivalB {
            title: field(name: "Title") {
              value
            }
            image: field(name: "Image") {
              ... on ImageField {
                src
              } 
            }
          }
          
          ... on CarnivalC {
            displayName
            title {
              value
            }
            horseTitle {
              value
            }
            trainer {
              value
            }
            horseImage {
              src
            }
            description {
              value
            }
            videosHeader {
              value
            }
            video1EnableDisable {
              boolValue
            }
            video1Source {
              value
            }
            video1LinkDiv {
              value
            }
            video1LinkScript {
              value
            }
            video1Link {
              value
            }
            video1Thumbnail {
              src
            }
            video1Description {
              value
            }
            video2EnableDisable {
              boolValue
            }
            video2Source {
              value
            }
            video2LinkDiv {
              value
            }
            video2LinkScript {
              value
            }
            video2Link {
              value
            }
            video2Thumbnail {
              src
            }
            video2Description {
              value
            }
            video3EnableDisable {
              boolValue
            }
            video3Source {
              value
            }
            video3LinkDiv {
              value
            }
            video3LinkScript {
              value
            }
            video3Link {
              value
            }
            video3Thumbnail {
              src
            }
            video3Description {
              value
            }
          }
        } 
      }
    }
  }
}
`;

export const SEARCH_CARNIVAL_BY_NAME = `
query SearchCarnivalByName($path: String, $language: String, $fieldsEqual: [ItemSearchFieldQuery], $limit: Int) {
  search(rootItem: $path, language: $language, fieldsEqual: $fieldsEqual, first: $limit) {
    results {
      items {
        carnivalPage: item {
          versions {
            version
          }
          displayName
          template {
            name
          }
          ... on CarnivalPage {
            carnivalName: field(name: "carnivalName") {
              value
            }
            raceDate: field(name: "raceDate") {
              ... on DateField {
                value
              }
              value
            }
            racecourseName: field(name: "racecourseName") {
              value
            }
            carnivalTabs: children {
              versions {
                version
              }
              displayName
              ... on CarnivalTab {
                tabLabel: field(name: "TabLabel") {
                  value
                }
                raceDate: field(name: "raceDate") {
                  ... on DateField {
                    value: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
                  }
                  value
                }
              }
              carnivalSection: children {
                versions {
                  version
                }
                displayName
                template {
                  name
                }
                ... on Text_Image {
                  title: field(name: "Title") {
                    value
                  }
                  image: field(name: "Image") {
                    ... on ImageField {
                      src
                    }
                  }
                  content: field(name: "Content") {
                    value
                  }
                  externalLink: field(name: "ExternalLink") {
                    value
                  }
                }
                ... on Image {
                  title: field(name: "Title") {
                    value
                  }
                  image: field(name: "Image") {
                    ... on ImageField {
                      src
                    }
                  }
                }
                ... on Key_Contenders {
                  displayName
                  title {
                    value
                  }
                  horseTitle {
                    value
                  }
                  trainer {
                    value
                  }
                  horseInfoDescription {
                    value
                  }
                  horseImage {
                    src
                  }
                  videosHeader {
                    value
                  }
                  video1EnableDisable {
                    boolValue
                  }
                  video1Source {
                    value
                  }
                  video1LinkDiv {
                    value
                  }
                  video1LinkScript {
                    value
                  }
                  video1Link {
                    value
                  }
                  video1Thumbnail {
                    src
                  }
                  video1Description {
                    value
                  }
                  video2EnableDisable {
                    boolValue
                  }
                  video2Source {
                    value
                  }
                  video2LinkDiv {
                    value
                  }
                  video2LinkScript {
                    value
                  }
                  video2Link {
                    value
                  }
                  video2Thumbnail {
                    src
                  }
                  video2Description {
                    value
                  }
                  video3EnableDisable {
                    boolValue
                  }
                  video3Source {
                    value
                  }
                  video3LinkDiv {
                    value
                  }
                  video3LinkScript {
                    value
                  }
                  video3Link {
                    value
                  }
                  video3Thumbnail {
                    src
                  }
                  video3Description {
                    value
                  }
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
}`;

export const GET_RACINGSTATISTICS = `
query GetRacingStatistics($path: String, $language: String) {
  item(path: $path, language: $language) {
    ... on RacingStatistics {
      children {
        name
        ... on RacingStatisticsText {
          template {
            name
          }
          title: field(name: "Title") {
            value
          }
          subTitle: field(name: "subTitle") {
            value
          }
          text: field(name: "Text") {
            value
            rendered
          }
        }
        ... on RacingStatisticsImage {
          template {
            name
          }
          title: field(name: "Title") {
            value
          }
          subTitle: field(name: "subTitle") {
            value
          }
          imageUrl: field(name: "Image") {
            ... on ImageField {
              src
            }
          }
        }
        ... on RacingStatisticsTable {
          template {
            name
          }
          title: field(name: "Title") {
            value
          }
          subTitle: field(name: "subTitle") {
            value
          }
          table: field(name: "Table") {
            value
          }
          remarks:field(name:"Remarks"){
            value
          }
        }
        ... on RacingStatisticsVideo {
          template {
            name
          }
          title: field(name: "Title") {
            value
          }
          subTitle: field(name: "subTitle") {
            value
          }
          video: field(name: "Video") {
            value
          }
          thumbnail: field(name: "Thumbnail") {
            ... on ImageField {
              src
            }
          }
          description:field(name:"Description"){
            value
          }
        }
      }
    }
  }
}
`;

export const GET_CARNIVAL_NAMES = `query CarnivalNameList($path: String, $language: String) {
  item(path: $path, language: $language) {
    children {
      ... on CarnivalName {
        displayName
        carnivalName {
          value
        }
      }
    }
  }
}`;

export const GET_CARNIVALSection = `
query CarnivalTab($language: String, $path: String) {
  item(language: $language, path: $path) {
    children {
      displayName
    }
  }
}
`;


export const GET_HORSE_FORMER_NAME = `
  query HorseFormerName {
    horses {
      id
      code
      name_en
      name_ch
      formerName
      sire
      dam
      importType
      cntyOfOrg {
        code
        chinese
        english
      }
      importDate
      age
      foalingDate
    }
  }
`;

export const GET_MEETINGCOUNTRY_HORSESTATUS_GIDS = `
query MeetingCountryHorseStatus($date: String, $venueCode: String) {
  raceMeetingProfile(date: $date, venueCode: $venueCode) {
    date
    country {
      code
      namech
      nameen
    }
    races{
      status
      no
      countryCodeNm {
        code
        english
        chinese
      }
      runners {
        no
        status
      } 
    }
  }
}
`;

export const GET_RACE_REPLAY = `
query($path: String, $language: String) {
  item(path: $path, language: $language) {  
    name
    replayList: children {
      name
      raceNoList: children {
        name
        ... on RaceReplayItem {
          raceNo{
            value
          }
          videoPresentorNot {
            targetItem {
              ... on SelectOption {
                option_Name {
                    value
                }
                option_Value {
                    value
                }
              }
            }
          }
          raceStatus {
            targetItem {
              ... on SelectOptions {
                option_Value {
                    value
                }
              }
            }
          }
          raceIndicator {
            targetItem {
              ... on SelectOptions {
                option_Value {
                    value
                } 
              }
            } 
          }
        }
        
        NoPassThroughBar: field(name: "NoPassThroughBar") {
          ... on CheckboxField{
            value:boolValue
          }
        }
        NoLeadingHorseButton: field(name: "NoLeadingHorseButton") {
          ... on CheckboxField{
            value:boolValue
          }
        }
      }
    } 
  }
}
`;

export const GET_UPCOMINGRACE_QIDS= `
query SIM_getUpcomingRace($localSim: LocalSim, $oddsTypes: [OddsType]) {
  commonMeetings(localSim: $localSim) {
    id
    venueCode
    date
    status
    season
    totalNumberOfRace
    currentNumberOfRace
    country {
      code
      namech
      nameen
      seq
    }
    races {
      id
      no
      postTime
      status
      raceResults {
        status
      }
      raceName_en
      raceName_ch
      raceTrack {
        code
        description_ch
        description_en
      }
      countryCodeNm {
        code
        english
        chinese
      }
    }
    pmPools(oddsTypes: $oddsTypes) {
      oddsType
      status
      leg {
        races
      }
    }
  }
}
`

export const GET_UPCOMINGRACE_CMS= `
query getUpcomingRaceCMS(
  $path: String
  $language: String
  $fieldsEqual: [ItemSearchFieldQuery]
  $from: String
  $to: String
  $racesFolderTemplateIDs: [String]
  $entriesFolderTemplateIDs: [String]
) {
  engLabelSearch: extendedSearch(
    fieldsEqual: $fieldsEqual
    rootItem: $path
    language: "en-us"
    dateFrom: $from
    dateTo: $to
    fieldName: "MeetingDate"
    sortBy: "MeetingDate"
    sortDesc: false
  ) {
    results {
      items {
        meeting: item {
          ... on MeetingDate {
            id
            name
            path
            displayName
            meetingCountry {
              value
            }
            meetingDate {
              date: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
              value: formattedDateValue(
                format: "yyyy-MM-ddTHH:mm:sszzz"
                offset: -480
              )
            }
            countryName {
              value
            }
          }
        }
      }
    }
  }
  extendedSearch(
    fieldsEqual: $fieldsEqual
    rootItem: $path
    language: $language
    dateFrom: $from
    dateTo: $to
    fieldName: "MeetingDate"
    sortBy: "MeetingDate"
    sortDesc: false
  ) {
    results {
      items {
        meeting: item {
          ... on MeetingDate {
            id
            name
            path
            displayName
            hasChildren
            season: parent {
              name
            }
            presite {
              boolValue
            }
            meetingDate {
              date: formattedDateValue(format: "yyyy-MM-dd", offset: -480)
              value: formattedDateValue(
                format: "yyyy-MM-ddTHH:mm:sszzz"
                offset: -480
              )
            }
            meetingVenueCode {
              value
            }
            meetingCountry {
              value
            }
            countryName {
              value
            }
            mainRace {
              targetItem {
                displayName
                path
                template {
                  id
                }
              }
            }
            RaceImages: raceImages {
              targetItems {
                ... on RaceImage {
                  RaceimageURL: raceimage {
                    src
                    alt
                  }
                }
              }
            }
            races: children(includeTemplateIDs: $racesFolderTemplateIDs) {
              raceInfo: children {
                ... on Race {
                  displayName
                  venueCode {
                    value
                  }
                  raceName {
                    value
                  }
                  raceDatetime {
                    value: formattedDateValue(
                      format: "yyyy-MM-ddTHH:mm:sszzz"
                      offset: -480
                    )
                  }
                  raceDistance {
                    value
                  }
                  entries: children(
                    includeTemplateIDs: $entriesFolderTemplateIDs
                  ) {
                    displayName
                  }
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
` 

export const GET_UPCOMING_HVST_Mt = `
query SIM_getUpcomingHVSTMt($venueCodes: [String!], $dates: [String!]) {
  commonMeetings(venueCodes: $venueCodes, dates: $dates) {
    id
    venueCode
    date
    status
    season
    totalNumberOfRace
    currentNumberOfRace
    races {
      id
      no
      postTime
      status
    }
    pmPools (oddsTypes: [WIN]) {
      oddsType
      status
      leg {
        races
      }
    }
  }
}
`;

export const RACE_REPLAY_VIDEOS = `query SIM_RaceReplayVideos($meetingDate: String!, $venueCode: String!, $raceNo: String) {
  raceReplayVideo(meetingDate: $meetingDate, venueCode: $venueCode, raceNo: $raceNo) {
    type
    meetingDate
    venue
    race {
      raceNo
      runnerNo
      raceReplayURL {
        lang
        replayURL
        replayDate
      }
    }
  }
}`;